var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"right-middle",attrs:{"title":"电梯品牌统计"}},[_c('barCharts',{attrs:{"id":"dtpptj","lists":_vm.datas}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }